export const INTAKE_SKIP_INITIAL_IMPORT_COPY = {
  label: "Skip initial import",
} as const;
